const messages = {
  step3: {
    actionBtn: "Kirjaudu sisään",
  },
};

export default {
  messages,
};
